// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"cc326c9e","37":"1dbe9a6b","255":"493d9c31","367":"165ad72c","470":"5a460b1e","480":"0f1639a3","507":"86a8a3f5","658":"c74b91b0","779":"e2892398","962":"b3dc603a"}[chunkId] + ".chunk.js";
};